import React from 'react';

const STEPS = [
  {
    num: '01',
    title: 'Sign up your community',
    desc: 'Create your community in minutes. Bring your villa list, gate camera (Cloud-ready), and contacts.',
  },
  {
    num: '02',
    title: 'Customize the experience',
    desc: 'Toggle features per community — chat, surveys, recommendations, payments. Pick what fits your culture.',
  },
  {
    num: '03',
    title: 'Onboard residents',
    desc: 'Send them a single link. They install the PWA, log in via OTP, and they\'re live — no app store needed.',
  },
];

export const HowItWorks = () => (
  <section
    id="how"
    className="py-24 lg:py-28 bg-gradient-to-b from-[#0B1120] to-white relative"
    data-testid="how-it-works-section"
  >
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="text-center max-w-2xl mx-auto mb-16">
        <p
          className="text-base md:text-lg tracking-wide uppercase text-[#14D4C6] font-semibold mb-3"
          style={{ fontFamily: 'Outfit, sans-serif' }}
        >
          From zero to live in a week
        </p>
        <h3
          className="text-3xl sm:text-4xl lg:text-5xl tracking-tight font-bold leading-tight text-white"
          style={{ fontFamily: 'Outfit, sans-serif' }}
          data-testid="how-it-works-headline"
        >
          How it works
        </h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-6 relative">
        {/* Connector line */}
        <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-px bg-gradient-to-r from-transparent via-[#14D4C6]/40 to-transparent" />

        {STEPS.map((s, i) => (
          <div
            key={s.num}
            className="relative bg-white rounded-2xl p-8 border border-slate-200 shadow-sm hover:shadow-lg transition-shadow"
            data-testid={`how-step-${i}`}
          >
            <div
              className="w-12 h-12 rounded-xl bg-[#14D4C6] text-slate-900 font-bold text-lg flex items-center justify-center mb-5"
              style={{ fontFamily: 'Outfit, sans-serif' }}
            >
              {s.num}
            </div>
            <h4
              className="text-xl font-semibold tracking-tight text-slate-900 mb-3"
              style={{ fontFamily: 'Outfit, sans-serif' }}
            >
              {s.title}
            </h4>
            <p
              className="text-sm text-slate-600 leading-relaxed"
              style={{ fontFamily: 'Work Sans, sans-serif' }}
            >
              {s.desc}
            </p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
